import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { validateFlagMessage } from "../lib/flag-message";

export function FlagDialog({
  open,
  onOpenChange,
  onSubmit,
  submitting,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (message: string) => void;
  submitting: boolean;
}) {
  const [message, setMessage] = useState("");
  const [touched, setTouched] = useState(false);
  const valid = validateFlagMessage(message);

  function submit() {
    setTouched(true);
    if (!valid) return;
    onSubmit(valid);
  }

  return (
    <Dialog
      open={open}
      onOpenChange={next => {
        onOpenChange(next);
        if (!next) {
          setMessage("");
          setTouched(false);
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Flag this script</DialogTitle>
          <DialogDescription>Tell the scanner what needs fixing. They will see this message.</DialogDescription>
        </DialogHeader>
        <Field invalid={touched && !valid}>
          <FieldLabel>Message</FieldLabel>
          <Textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            onBlur={() => setTouched(true)}
            rows={3}
            placeholder="e.g. retake page 2, it's blurry"
          />
          {touched && !valid && <FieldError match>A message is required.</FieldError>}
        </Field>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={submit} disabled={submitting}>
            Flag
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
